// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"5bdc48e2","531":"d4876384","937":"28a08963"}[chunkId] + ".chunk.js";
};